import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { GroupService } from '../../../services/group.service';
import { ChartService } from '../../../services/chart.service';
import { DRAWER_DATA } from 'src/app/shared/injector-tokens';
import { DoughnutChartComponent } from '../../../shared/doughnut-chart/doughnut-chart.component';
import { DrawerLayoutComponent } from '../../drawer-layout/drawer-layout.component';
import { DrawerStatComponent } from '../../drawer-layout/drawer-stat.component';

@Component({
    selector: 'app-categories-pie-chart-drawer-wrapper',
    templateUrl: './categories-pie-chart-drawer-wrapper.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DrawerLayoutComponent, DrawerStatComponent, DoughnutChartComponent],
})
export class CategoriesPieChartDrawerWrapperComponent {
  public readonly data = inject(DRAWER_DATA) as { groupId?: string };
  public readonly groupService = inject(GroupService);
  private readonly chartService = inject(ChartService);
  readonly categoryPageQuery = injectQuery(() => this.groupService.groupPageQueryOptions());
  readonly chartData = computed(() => {
    const groupPage = this.categoryPageQuery.data();
    if (!groupPage) return null;

    const expected = this.chartService.groupChartExpected(groupPage, this.data.groupId);
    const actual = this.chartService.groupChartActual(groupPage, this.data.groupId);
    return {
      expected: expected.some(e => e.amount > 0) ? expected : [],
      actual: actual.some(a => a.amount > 0) ? actual : [],
    };
  });
  readonly drawerTitle = computed(() => {
    const groupPage = this.categoryPageQuery.data();
    if (!this.data.groupId || this.data.groupId === 'undefined') return 'Monthly Report';
    // A non-empty fallback keeps the drawer's accessible name while the page loads.
    return groupPage?.data.find(category => category.id === this.data.groupId)?.name ?? 'Group';
  });
  readonly balance = computed(() => {
    const categories = this.categoryPageQuery.data()?.data ?? [];
    if (!this.data.groupId || this.data.groupId === 'undefined')
      return categories.reduce((acc, category) => acc + category.fundBalance.BUDGET + category.fundBalance.INCOME, 0);

    const category = categories.find(category => category.id === this.data.groupId);
    return category ? category.fundBalance.INCOME + category.fundBalance.BUDGET : 0;
  });
}
